import Highcharts, { Options, SeriesOptions } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
// eslint-disable-next-line import/no-internal-modules
// import HC_exporting from 'highcharts/modules/exporting';
import React, { FC } from 'react';

// init the module
// HC_exporting(Highcharts);

interface ChartProps {
  series: SeriesOptions;
}

const options: Options = {
  chart: {
    plotShadow: false,
    plotBackgroundColor: undefined,
    plotBorderWidth: undefined,
    type: 'pie',
    height: 184,
    width: 192,
    style: {
      fontFamily: 'var(--font-family)',
    },
  },
  title: {
    text: undefined,
  },
  tooltip: {
    pointFormat: '<b>{point.percentage:.1f}%</b>',
  },
  accessibility: {
    point: {
      valueSuffix: undefined,
    },
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
        format: '<b>{point.name}</b>: {point.percentage:.1f}%',
      },
      showInLegend: false,
    },
  },
};

export const Chart: FC<ChartProps> = ({ series }) => {
  return (
    <HighchartsReact highcharts={Highcharts} options={{ ...options, series }} />
  );
};
